import {BooleanNumField} from '@/components/field'
import ProducerBulkActions from '@/producers/components/BulkActions'
import {Commune, Producer} from '@/types'
import {Chip, Tooltip, Typography} from '@mui/material'
import * as React from 'react'
import {ReactNode} from 'react'
import {Datagrid, DatagridProps, EditButton, FunctionField, ReferenceField, TextField} from 'react-admin'

const DatagridActionsColumn = ({label, children}: {
    label: string | ReactNode,
    children: ReactNode
}) => <>{children}</>

export default function DatagridProducers(props: DatagridProps) {
    return (
        <Datagrid
            optimized
            rowClick="edit"
            bulkActionButtons={
                <ProducerBulkActions/>
            }
            {...props}
        >
            <TextField source="id" label="Identifiant"/>
            <FunctionField
                label="Dénomination"
                render={(record: Producer) =>
                    <>
                        <Typography variant={'subtitle1'}>{record.name}</Typography>
                        <Typography variant={'subtitle2'}>{record.name_enterprise}</Typography>
                    </>
                }
            />
            {/*<TextField source="name" label="Nom commercial"/>*/}
            {/*<TextField source="name_enterprise" label="Entreprise"/>*/}
            <ReferenceField source="commune" reference="communes" label="Commune">
                <FunctionField
                    label="Vente direct"
                    render={(record: Commune) =>
                        <span>{record.name}</span>
                    }
                />
            </ReferenceField>
            {/*<TextField source="email" label="Email principal"/>*/}

            <ReferenceField source="activity" label="Activité" reference="producers/activities">
                <TextField source="name"/>
            </ReferenceField>
            <FunctionField
                source="administrative_status"
                label="Statut administratif"
                render={(record: Producer) => {
                    if (!record.administrative_status) return '-'
                    
                    const isActive = record.administrative_status === 'A'
                    const statusText = isActive ? 'Actif' : 'Cessé'
                    const color = isActive ? 'success' : 'warning'
                    
                    const chipElement = (
                        <Chip 
                            label={statusText} 
                            color={color}
                            size="small"
                            variant="outlined"
                        />
                    )
                    
                    // If status is 'C' and we have cessation date, show it in tooltip
                    if (!isActive && record.cessation_date) {
                        const cessationDate = new Date(record.cessation_date).toLocaleDateString('fr-FR')
                        return (
                            <Tooltip title={`Cessé le ${cessationDate}`}>
                                {chipElement}
                            </Tooltip>
                        )
                    }
                    
                    return chipElement
                }}
            />
            {/*<ReferenceField source="activity_secondary" label="Activité secondaire"*/}
            {/*                reference="producers/activities">*/}
            {/*    <TextField source="name"/>*/}
            {/*</ReferenceField>*/}
            <FunctionField
                source="is_validated"
                label="Validé"
                render={(record: any, source: any) =>
                    <BooleanNumField
                        label="Validé"
                        source={source}
                    />
                }
            />
            <FunctionField
                source="is_published"
                label="Publié"
                render={(record: any, source: any) =>
                    <BooleanNumField
                        label="Publié"
                        source={source}
                    />
                }
            />
            <FunctionField
                source="ca"
                label="Chiffre d'affaires"
                sortable={true}
                render={(record: Producer) => {
                    if (!record.ca) return '-'
                    return `${parseFloat(record.ca).toLocaleString('fr-FR')} €`
                }}
            />
            <FunctionField
                source="capital_social"
                label="Capital social"
                sortable={true}
                render={(record: Producer) => {
                    if (!record.capital_social) return '-'
                    return `${parseFloat(record.capital_social).toLocaleString('fr-FR')} €`
                }}
            />
            <DatagridActionsColumn
                label=""//{<LinkUserDialog/>}
            >
                <EditButton/>
            </DatagridActionsColumn>
        </Datagrid>
    )
}
